"use client";

import { Box, ChartColumn, ChartScatter, Grid2x2 } from "lucide-react";
import type { ReactNode } from "react";
import { SegmentTabs } from "@/components/motion/segment-tabs";
import type { ProjectionMode } from "./chart-projection-context";
import type { ProjectionKind } from "./iso-projection";

export type ChartView = "2d" | "3d";

export const chartViewToMode = (view: ChartView): ProjectionMode =>
  view === "3d" ? "isometric" : "flat";

const FLAT_ICONS: Record<ProjectionKind, ReactNode> = {
  bar: <ChartColumn className="size-3.5" aria-hidden />,
  scatter: <ChartScatter className="size-3.5" aria-hidden />,
  heatmap: <Grid2x2 className="size-3.5" aria-hidden />,
  quadrant: <Grid2x2 className="size-3.5" aria-hidden />,
};

export interface ChartViewToggleProps {
  value: ChartView;
  onChange: (view: ChartView) => void;
  kind: ProjectionKind;
  flatIcon?: ReactNode;
  className?: string;
}

export function ChartViewToggle({
  value,
  onChange,
  kind,
  flatIcon,
  className,
}: ChartViewToggleProps) {
  return (
    <SegmentTabs
      value={value}
      onValueChange={(next) => {
        if (next === "2d" || next === "3d") onChange(next);
      }}
      options={[
        { value: "2d", label: "2D", leading: flatIcon ?? FLAT_ICONS[kind] },
        { value: "3d", label: "3D", leading: <Box className="size-3.5" aria-hidden /> },
      ]}
      className={className}
    />
  );
}
